import CButton from "components/CButton";
import CDialog from "components/CDialog";
import LoginIcon from "assets/Images/login.svg";
import color from "context/MaterialUITheme/color";
import { Box, Grid, Typography } from "@mui/material";
import IncomeIcon from "assets/Images/income-info.svg";
import CredentialsIcon from "assets/Images/credentials.svg";
import SecureEnvironmentIcon from "assets/Images/secure-environment.svg";

export type PlaidWarningProps = {
  open: boolean;
  onAccept: () => void;
};

const PlaidWarning: React.FC<PlaidWarningProps> = ({ open, onAccept }) => {
  return (
    <CDialog maxWidth="md" open={open}>
      <Typography variant="h5" fontFamily="Pro Display Semibold">
        NFTYDoor uses Plaid, a trusted and secure third party, to verify your
        income
      </Typography>
      <Grid
        my={4}
        container
        rowSpacing={4}
        columnSpacing={{ xs: 2, sm: 2, md: 3 }}
      >
        <Grid item xs={6}>
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box height={"50px"}>
              <img src={LoginIcon} alt={""} style={{ height: "60px" }} />
            </Box>

            <Box
              mt={4}
              width={"2rem"}
              height={"2rem"}
              display={"flex"}
              borderRadius={"50%"}
              alignItems={"center"}
              bgcolor={color.purple}
              justifyContent={"center"}
            >
              <Typography color={color.white}>1</Typography>
            </Box>
            <Typography fontSize={{ xs: "0.8rem", md: "1rem" }}>
              Login with your bank via a secure and encrypted connection.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box height={"50px"}>
              <img src={IncomeIcon} alt={""} style={{ height: "60px" }} />
            </Box>

            <Box
              mt={4}
              width={"2rem"}
              height={"2rem"}
              display={"flex"}
              borderRadius={"50%"}
              alignItems={"center"}
              bgcolor={color.purple}
              justifyContent={"center"}
            >
              <Typography color={color.white}>2</Typography>
            </Box>
            <Typography fontSize={{ xs: "0.8rem", md: "1rem" }}>
              We pull only the required income information.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box height={"50px"}>
              <img
                src={SecureEnvironmentIcon}
                alt={""}
                style={{ height: "60px" }}
              />
            </Box>

            <Box
              mt={4}
              width={"2rem"}
              height={"2rem"}
              display={"flex"}
              borderRadius={"50%"}
              alignItems={"center"}
              bgcolor={color.purple}
              justifyContent={"center"}
            >
              <Typography color={color.white}>3</Typography>
            </Box>
            <Typography fontSize={{ xs: "0.8rem", md: "1rem" }}>
              We store it in a secured environment and analyze quickly.
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            display={"flex"}
            alignItems={"center"}
            flexDirection={"column"}
            justifyContent={"center"}
          >
            <Box height={"50px"}>
              <img src={CredentialsIcon} alt={""} style={{ height: "35px" }} />
            </Box>
            <Box
              mt={4}
              width={"2rem"}
              height={"2rem"}
              display={"flex"}
              borderRadius={"50%"}
              alignItems={"center"}
              bgcolor={color.purple}
              justifyContent={"center"}
            >
              <Typography color={color.white}>4</Typography>
            </Box>
            <Typography fontSize={{ xs: "0.8rem", md: "1rem" }}>
              You’re in control. Change your login credentials any time.
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <CButton
        fullWidth
        type="submit"
        variant="contained"
        onClick={onAccept}
        sx={{ marginTop: 4 }}
      >
        Proceed Securely
      </CButton>
    </CDialog>
  );
};

export default PlaidWarning;
